<template>
  <Grid gtc="1.5fr 1fr" gap="var(--r-space-md) var(--r-space-sp)">
    <Grid align-content="start" gap="var(--r-space-md) var(--r-space-sp)">
      <TodoList
        :component="{ type: 'to-do-list' }"
        :context-url="`/vendor/${id}`"
        title="Tasks"
        from-page="vendor"
        @uncompleted-count="updateUncompletedTodos"
      />

      <Notes :entity="{ name: 'vendor', id }" :fill-vertical-space="true" store-namespace="vendors" />
    </Grid>

    <Grid align-content="start" gap="var(--r-space-md) var(--r-space-sp)">
      <Links :dropdown-initial-value="linksCategories" :entity="{ name: 'vendor', id }" store-namespace="vendors" />
      <Attachments :entity="{ name: 'vendor', id }" store-namespace="vendors" />
    </Grid>
  </Grid>
</template>

<script>
import { linksCategories } from '@/reusable/data/links-categories'
// Mixins
import { registerVuexModule } from '@/mixins/register-vuex-module'
// Libraries
import { mapGetters, mapMutations } from 'vuex'
// Components
import Notes from '@components/lm-blocks/Notes.vue'
import Links from '@components/lm-blocks/Links.vue'
import Attachments from '@components/lm-blocks/Attachments.vue'
import TodoList from '@/components/general/ToDoList/ToDoList'

export default {
  components: {
    Notes,
    Links,
    Attachments,
    TodoList
  },

  mixins: [registerVuexModule('todo-modal', () => require('@/reusable/TodoModal/vuex/TodoModal'))],

  props: {
    id: [Number, String] // from route
  },

  computed: {
    ...mapGetters('vendor-show', ['vendor']),
    linksCategories
  },

  watch: {
    vendor: {
      handler(val) {
        val && this.setEntityForTodo(val)
      },
      immediate: true
    }
  },

  methods: {
    ...mapMutations('todo-modal', ['resetCreateData', 'setEntityForTodo']),
    ...mapMutations('vendor-show', ['updateUncompletedTodos'])
  }
}
</script>
